import React from 'react';
import {Button} from 'reactstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faShoppingCart} from '@fortawesome/free-solid-svg-icons';
import './ClaimedItemsBar.scss';
import * as actions from '../EmbeddableApi';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import ResourceComponent from '../../../common/ResourceComponent';
import {getBackgroundColor, reverseColor} from '../../../common/Utils';

class ClaimedItemsBar extends ResourceComponent {

    render() {
        const {ecommerceConnected, claimedItems, onSubmit, settings, claimEnabled, sendEventData} = this.props;
        const backgroundColor = getBackgroundColor(settings.left_container_color);
        const color = reverseColor(backgroundColor);

        return (
            <div className='claimed-items-bar' style={{backgroundColor, color}}>
                {(claimEnabled || (!claimEnabled && ecommerceConnected)) &&
                    <React.Fragment>
                        {claimEnabled &&
                            <span className='mr-3 mb-0'>
                            Claimed Items:<span><b> {claimedItems.length}</b></span>
                        </span>}
                        {!claimEnabled
                            ? <Button className='mr-1 cart-btn' size='sm' onClick={onSubmit}>
                                <span className='h6'>
                                    <FontAwesomeIcon icon={faShoppingCart} />
                                    Items In Cart: <span className='h5'><b> {claimedItems.length}</b></span>
                                </span>
                            </Button>
                            : <Button className='mr-1' size='sm' color='success' onClick={onSubmit}>
                                Submit
                            </Button>}
                        {claimEnabled &&
                            <Button className='mr-3' size='sm' color='danger'
                                    onClick={() => {
                                        sendEventData('remove_from_cart', {
                                            currency: 'USD',
                                            value: claimedItems.reduce((acc, i) => acc + +i.price, 0),
                                            items: claimedItems.map(i => ({
                                                item_name: i.inventory_number ? `Pack: ${i.inventory_number}` : `Slab: ${i.number}`,
                                                price: i.price,
                                            })),
                                        });
                                        this.props.actions.emptyClaimedItems();
                                    }}>
                                Cancel
                            </Button>}
                    </React.Fragment>}
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        actions,
        dispatch),
});

export default connect(
    null,
    mapDispatchToProps,
)(ClaimedItemsBar);


// WEBPACK FOOTER //
// ./src/containers/embeddable/utils/ClaimedItemsBar.js